import type { z } from "zod";

export type FieldErrors = Readonly<Record<string, string>>;

/**
 * Validates form values with the same Zod contract the API uses, so the browser and the
 * server always agree on the rules. Returns the parsed data or the first message per field.
 */
export function validate<TSchema extends z.ZodType>(
  schema: TSchema,
  values: unknown,
): { ok: true; data: z.output<TSchema> } | { ok: false; errors: FieldErrors } {
  const result = schema.safeParse(values);
  if (result.success) return { ok: true, data: result.data };
  const errors: Record<string, string> = {};
  for (const issue of result.error.issues) {
    const key = issue.path.length > 0 ? issue.path.map(String).join(".") : "form";
    errors[key] ??= issue.message;
  }
  return { ok: false, errors };
}
